import { colors, sizes } from "@hubrise/react-components"
import styled, { css } from "styled-components"

export const Bar = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledLink = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.1rem;
  padding: 1rem 2rem;
  line-height: 1;
  border-radius: 0 ${sizes.borderRadius} ${sizes.borderRadius} 0;
  transition: background-color 0.1s;
  cursor: pointer;

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${colors.backgroundLightest};
      font-weight: 500;
    `}

  &:hover {
    background-color: ${colors.backgroundWhite};
  }
`

export const Icon = styled.div``

export const Label = styled.div``
